import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Constraints } from 'hooks/webapi/application/useConstraintsQuery';
import useEventCollector from 'hooks/context/EventCollector/useEventCollector';
import CalculatorEvent from 'hooks/context/EventCollector/events/CalculatorEvent';
import SkeletonSlider from './SkeleonSlider';
import Slider from '../Slider/Slider';

export type Props = {
  onAmountChange: (value: number) => void;
  constraints?: Constraints;
  amount?: number;
  dataTest?: string;
};

export default function Sliders({
  onAmountChange,
  constraints,
  amount,
  dataTest = 'sliders',
}: Props) {
  const { t } = useTranslation('calculator');
  const { track } = useEventCollector();

  const handleAmountChange = useCallback(
    (value: number) => {
      onAmountChange(value);
      track(
        new CalculatorEvent({
          description: 'calculator amount change',
          value,
        }),
      );
    },
    [onAmountChange, track],
  );

  return (
    <div data-test={`${dataTest}-calculator`}>
      {constraints ? (
        <Slider
          dataTest="amount-slider"
          min={constraints.amountInterval.min}
          max={constraints.amountInterval.max}
          step={constraints.amountInterval.step}
          value={amount ?? constraints.amountInterval.defaultValue}
          onAfterChange={handleAmountChange}
          units={t('amount_units')}
        />
      ) : (
        <SkeletonSlider />
      )}
    </div>
  );
}
